<script setup lang="ts">
import type { Swiper } from 'swiper/types';

const carousel = useTemplateRef('carousel_ref');
const swiper = computed(() => carousel.value?.swiper as Swiper | undefined);

const title = 'Jak to u nás vypadá';
</script>

<template>
  <PageContainerAlignment
    as="section"
    class="py-r12 lg:py-r18 gap-r4 lg:gap-r12 flex flex-col"
  >
    <div class="gap-r6 flex items-center justify-between">
      <AppHeading tag="h2" class="text-client-black">
        {{ title }}
      </AppHeading>
      <AppSwiperControls v-if="swiper" :swiper />
    </div>
    <IndexGalleryCarousel ref="carousel_ref" />
  </PageContainerAlignment>
</template>
